import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactGA from 'react-ga4';
import { ShieldCheck } from 'lucide-react';

const CookieBanner: React.FC = () => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookies_accepted');
    if (!accepted) {
      setShowBanner(true);
    } else if (accepted === 'true') {
      ReactGA.initialize(process.env.REACT_APP_GA_ID!);
    }
  }, []);

  const acceptCookies = () => {
    ReactGA.initialize(process.env.REACT_APP_GA_ID!);
    localStorage.setItem('cookies_accepted', 'true');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookies_accepted', 'false');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 max-w-2xl mx-auto backdrop-blur bg-[#0A192FCC]/80 border border-blue-500 rounded-xl p-5 shadow-2xl">
      <div className="flex items-start gap-4">
        <ShieldCheck className="w-6 h-6 text-blue-400 mt-1" />

        <div className="flex-1">
          <p
            className="text-sm text-gray-200"
            dangerouslySetInnerHTML={{ __html: t('cookieBanner.message') }}
          />

          <div className="flex justify-end gap-3 mt-4">
            <button
              onClick={declineCookies}
              className="text-sm px-4 py-1.5 rounded-md border border-gray-500 text-gray-300 hover:text-white hover:border-white transition"
            >
              {t('cookieBanner.reject')}
            </button>
            <button
              onClick={acceptCookies}
              className="text-sm px-4 py-1.5 rounded-md bg-blue-600 hover:bg-blue-700 text-white transition font-medium"
            >
              {t('cookieBanner.accept')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
